import { Box, Button, TextField } from "@material-ui/core"
import type { ReactElement } from "react"
import { connect } from "react-redux"

import { pushMessage } from "../../../redux"
import type { AppThunkDispatch, SnackbarAction } from "../../../redux"
import { Body1, NotSavedWarning, SubTitle1 } from "../../atoms"
import { DialogWindow, DialogWindowHeader } from "../../molecules"

import "./assignment-dialog.styles.scss"
import { useTranslation } from "react-i18next"
import { mapObjectDescriptorToTranslation } from "../../../utils"

export interface IAssignmentDialogProps {
  open: boolean
  shouldSave?: boolean
  url?: string
  objectDescriptor: "map" | "comparison"
  onSave: () => void
  onClose: () => void
}

export interface IAssignmentDialogStateProps {
  pushSuccessMessage: (text: string) => void
}

export function AssignmentDialogView(props: IAssignmentDialogProps & IAssignmentDialogStateProps): ReactElement {
  const { open, shouldSave, objectDescriptor, url, onClose, onSave, pushSuccessMessage } = props

  const { t } = useTranslation("general")

  const link: string = window.location.href

  function handleCopyClick() {
    navigator.clipboard.writeText(url ? url : link)
    pushSuccessMessage(t("optionsButton.handInAssignment.linkCopied"))
  }

  return (
    <DialogWindow open={open} onClose={onClose} className="assignment-dialog">
      <DialogWindowHeader
        title={t("optionsButton.handInAssignment.handInAssignmentTitle", {
          type: mapObjectDescriptorToTranslation(objectDescriptor)
        })}
        onClose={onClose}
      />
      {shouldSave && (
        <NotSavedWarning
          text={t("optionsButton.handInAssignment.afterEdit", {
            type: mapObjectDescriptorToTranslation(objectDescriptor)
          })}
          onSave={onSave}
        />
      )}
      <Box className="assignment-dialog-content">
        <Body1>
          {t("optionsButton.handInAssignment.copyLinkClipboard", {
            type: mapObjectDescriptorToTranslation(objectDescriptor)
          })}
        </Body1>
        <Box>
          <SubTitle1>
            {t("optionsButton.handInAssignment.linkAssignment", {
              type: mapObjectDescriptorToTranslation(objectDescriptor)
            })}
          </SubTitle1>
          <TextField
            value={url ? url : link}
            className={`assignment-link ${shouldSave ? "disabled" : ""}`}
            disabled={shouldSave}
            fullWidth
            variant="outlined"
            InputProps={{
              endAdornment: (
                <Button disabled={shouldSave} onClick={handleCopyClick} variant="contained" color="primary">
                  {t("copy")}
                </Button>
              )
            }}
          />
        </Box>
      </Box>
    </DialogWindow>
  )
}

function mapDispatchToProps(dispatch: AppThunkDispatch<SnackbarAction>) {
  return {
    pushSuccessMessage: (text: string) => dispatch(pushMessage(text))
  }
}

export const AssignmentDialog = connect(undefined, mapDispatchToProps)(AssignmentDialogView)
